/*
 * nf-tabnav — pestañas con indicador deslizante (estilo Apple TabNav).
 * Auto-inicializa todo nodo .nf-tabnav del documento.
 *
 * Markup esperado:
 *   <nav class="nf-tabnav" data-panel-active-class="nf-panel--active">
 *     <div class="nf-tabnav__track" role="tablist">
 *       <span class="nf-tabnav__indicator" aria-hidden="true"></span>
 *       <button class="nf-tabnav__tab" role="tab" aria-selected="true" data-tab="PANEL_ID">…</button>
 *       …
 *     </div>
 *   </nav>
 * Cada data-tab apunta al id del panel que controla.
 *
 * Paddles (flechas): se inyectan cuando las pestañas no entran. Al hacer click
 * AVANZAN a la pestaña siguiente/anterior (cambian la selección), igual que Apple.
 *
 * 17-oct (Josué): en el CELULAR no hay flechas ni fade. La barra ocupa todo el ancho de la
 * pantalla y se desliza con el dedo hasta los bordes (la que se desplaza es la <nav>, no el
 * track; ver la regla 8 de component-list-menu.css). La compu sigue igual (estilo Apple).
 * Por eso aquí el desplazamiento se hace sobre "el que tenga scroll" (scroller()).
 */
(function () {
  if (window.__nfTabnavInit) return;
  window.__nfTabnavInit = true;

  var PADDLE_CLEARANCE = 60; // px que se dejan libres para que la flecha no tape la pestaña activa

  function initTabnav(nav) {
    if (nav.dataset.tabnavReady) return;
    nav.dataset.tabnavReady = 'true';

    var track = nav.querySelector('.nf-tabnav__track');
    var indicator = nav.querySelector('.nf-tabnav__indicator');
    var tabs = Array.prototype.slice.call(nav.querySelectorAll('[role="tab"]'));
    if (!track || !tabs.length) return;

    var activeClass = nav.dataset.panelActiveClass || 'is-active';

    function panelFor(tab) {
      var id = tab.getAttribute('data-tab');
      return id ? document.getElementById(id) : null;
    }

    function activeTab() {
      return tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
    }

    function moveIndicator(tab) {
      if (!indicator) return;
      indicator.style.width = tab.offsetWidth + 'px';
      indicator.style.height = tab.offsetHeight + 'px';
      indicator.style.transform = 'translate(' + tab.offsetLeft + 'px, ' + tab.offsetTop + 'px)';
    }

    function placeNoAnim(tab) {
      if (!indicator) return;
      var prev = indicator.style.transition;
      indicator.style.transition = 'none';
      moveIndicator(tab);
      void indicator.offsetWidth; // forzar reflow
      indicator.style.transition = prev;
    }

    // Celular: se desplaza la <nav> (a todo el ancho). Compu: el track.
    function scroller() {
      var ox = window.getComputedStyle(nav).overflowX;
      return (ox === 'auto' || ox === 'scroll') ? nav : track;
    }

    // Desplaza para que la pestaña quede visible (y despejada del paddle en compu).
    function scrollTabIntoView(tab, behavior) {
      var sc = scroller();
      var clear = sc === nav ? (parseFloat(window.getComputedStyle(nav).paddingLeft) || 24) : PADDLE_CLEARANCE;
      var left = tab.getBoundingClientRect().left - sc.getBoundingClientRect().left + sc.scrollLeft;
      var right = left + tab.offsetWidth;
      var opts = { behavior: behavior || 'smooth' };
      if (left - clear < sc.scrollLeft) {
        opts.left = Math.max(0, left - clear);
        sc.scrollTo(opts);
      } else if (right + clear > sc.scrollLeft + sc.clientWidth) {
        opts.left = right + clear - sc.clientWidth;
        sc.scrollTo(opts);
      }
    }

    // ── Paddles: avanzan a la pestaña siguiente/anterior ──
    var CHEVRON = '<svg viewBox="0 0 8 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="DPATH"/></svg>';
    function makePaddle(dir, label, dpath) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nf-tabnav__paddle nf-tabnav__paddle--' + dir;
      b.setAttribute('aria-label', label);
      b.tabIndex = -1;
      b.innerHTML = CHEVRON.replace('DPATH', dpath);
      b.addEventListener('click', function () {
        var i = tabs.indexOf(activeTab());
        var target = dir === 'next' ? tabs[i + 1] : tabs[i - 1];
        if (target) activate(target, { scroll: true });
      });
      return b;
    }
    var prevPaddle = makePaddle('prev', 'Pestaña anterior', 'M7 1 1 7l6 6');
    var nextPaddle = makePaddle('next', 'Pestaña siguiente', 'M1 1l6 6-6 6');
    nav.appendChild(prevPaddle);
    nav.appendChild(nextPaddle);

    // La flecha "siguiente" aparece si hay una pestaña después de la activa; la
    // "anterior" si hay alguna antes. Se ocultan en la última/primera pestaña.
    // Sólo cuando las pestañas desbordan (si entran todas, no hacen falta).
    // En el celular el track nunca desborda (desborda la nav), así que no salen.
    function updatePaddles() {
      var overflow = track.scrollWidth - track.clientWidth > 1;
      var i = tabs.indexOf(activeTab());
      prevPaddle.classList.toggle('is-visible', overflow && i > 0);
      nextPaddle.classList.toggle('is-visible', overflow && i < tabs.length - 1);
    }

    // Máscara de fade en los bordes (Apple TabNav, solo compu): al inicio el fade va solo a la
    // derecha; al final solo a la izquierda; en medio, a ambos lados.
    function updateMask() {
      var overflow = track.scrollWidth - track.clientWidth > 1;
      nav.classList.toggle('has-overflow', overflow);
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      nav.style.setProperty('--tabnav-mask-first', overflow && !atStart ? 'transparent' : 'black');
      nav.style.setProperty('--tabnav-mask-last', overflow && !atEnd ? 'transparent' : 'black');
    }
    var maskRaf = null;
    track.addEventListener('scroll', function () {
      if (maskRaf) return;
      maskRaf = requestAnimationFrame(function () { maskRaf = null; updateMask(); });
    }, { passive: true });

    function activate(tab, opts) {
      opts = opts || {};
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.classList.toggle('is-active', on);
        t.tabIndex = on ? 0 : -1;
        var panel = panelFor(t);
        if (panel) {
          panel.classList.toggle(activeClass, on);
          panel.hidden = !on;
        }
      });
      moveIndicator(tab);
      updatePaddles();
      updateMask();
      if (opts.focus) tab.focus({ preventScroll: true });
      if (opts.scroll || opts.focus) scrollTabIntoView(tab);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { activate(tab, { scroll: true }); });
      tab.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(tab);
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { next = tabs[(i + 1) % tabs.length]; }
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { next = tabs[(i - 1 + tabs.length) % tabs.length]; }
        else if (e.key === 'Home') { next = tabs[0]; }
        else if (e.key === 'End') { next = tabs[tabs.length - 1]; }
        if (next) { e.preventDefault(); activate(next, { focus: true }); }
      });
    });

    var revealed = false;
    function refresh() {
      // Celular: el espacio al final del deslizamiento = el margen de la página (el mismo del inicio).
      if (scroller() === nav) nav.style.setProperty('--tabnav-gutter', window.getComputedStyle(nav).paddingLeft);
      placeNoAnim(activeTab());
      updatePaddles();
      updateMask();
      // Celular: si la pestaña activa (p. ej. la de la colección abierta) está fuera de la
      // pantalla, se deja a la vista al cargar, sin animación.
      if (!revealed && scroller() === nav && nav.scrollWidth > nav.clientWidth) {
        revealed = true;
        scrollTabIntoView(activeTab(), 'auto');
      }
    }

    refresh();
    nav.classList.add('is-ready'); // habilita el color de texto activo (ver base.v2.css)

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(refresh);
    }
    window.addEventListener('load', refresh);

    if ('ResizeObserver' in window) {
      new ResizeObserver(refresh).observe(track);
    } else {
      window.addEventListener('resize', refresh);
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('.nf-tabnav').forEach(initTabnav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();